module.exports = __webpack_public_path__ + "static/media/MIAB9924-180731-132_Small.6796dead.jpg";